import reduce from 'lodash/reduce';
import concat from 'lodash/concat';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import thumbnail from '../../components/ThumborImage/thumbor';
import ogp from '../../constants/ogp';
import { SITE_HOST } from '../../constants/index';
import CURRENCIES from '../../constants/currencies';

import { itemUrl } from './urls';

function getRegion(regions, pk) {
  const tmp = reduce(
    regions,
    (result, item) => {
      result.push(item);
      return concat(result, item.childrens);
    },
    [],
  );
  return find(tmp, { id: pk });
}

const itemTitle = (item, defaultTitle = '') =>
  `${item ? item.title : defaultTitle}`;

export function seoTitle({ query, store, localize }) {
  const DEFAULT_TITLE = localize('Легкові');

  if (!isEmpty(query)) {
    const { make, model, locations } = query;
    const data = store.getState('search_form').search_form;

    if (make && model && locations) {
      const makeItem = find(data.makes, { id: make });
      const modelItem = find(data.models, { id: model });
      const region = getRegion(data.locations, locations);
      return `${DEFAULT_TITLE}. ${itemTitle(makeItem)} ${itemTitle(
        modelItem,
      )}. ${itemTitle(region)}.`;
    } else if (make && locations) {
      const makeItem = find(data.makes, { id: make });
      const region = getRegion(data.locations, locations);
      return `${DEFAULT_TITLE}. ${itemTitle(makeItem)}. ${itemTitle(region)}.`;
    } else if (make && model) {
      const makeItem = find(data.makes, { id: make });
      const modelItem = find(data.models, { id: model });
      return `${DEFAULT_TITLE}. ${itemTitle(makeItem)} ${itemTitle(
        modelItem,
      )}.`;
    } else if (make) {
      const makeItem = find(data.makes, { id: make });
      return `${DEFAULT_TITLE}. ${itemTitle(makeItem)}.`;
    } else if (locations) {
      const region = getRegion(data.locations, locations);
      return `${DEFAULT_TITLE}. ${itemTitle(region)}.`;
    }
  }
  return DEFAULT_TITLE;
}

export function seoDescription({ localize }) {
  const DEFAULT_DESCRIPTION = localize(
    'Продаж авто в Україні. Найсвіжіші оголошення. Купити чи продати Б/В авто вигідніше з Avtoprod.ua',
  );
  // if (!_.isEmpty(query)) {
  //   const { make, model, locations } = query;
  //   if (make && model && locations) {
  //     console.log('Template for make + model + region');
  //   } else if (make && model) {
  //     console.log('Template for make + model');
  //   } else if (make) {
  //     console.log('Template for make');
  //   } else if (locations) {
  //     console.log('Template for Locations');
  //   }
  //   return DEFAULT_DESCRIPTION
  // }
  return DEFAULT_DESCRIPTION;
}

export function seoItemTitle({ car, localize }) {
  return localize(
    'Продаж {car}, {location}, ціна {price} {currency} (id {id})',
    {
      car: car.title,
      location: car.location.title,
      price: car.price,
      currency: CURRENCIES[car.price_currency],
      id: car.id,
    },
  );
}

export function seoItemOgp({ car, localize }) {
  const { images } = car;
  return {
    ...ogp,
    type: 'article',
    title: seoItemTitle({ car, localize }),
    description: car.description,
    url: `${SITE_HOST}${itemUrl(car)}`,
    ...(images && images.length > 0
      ? { image: thumbnail(images[0].url, 640) }
      : null),
  };
}
